var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
// import throttle from 'lodash.throttle'
import { getBlockIcon, getBlockTitle, getTextContent, getPageTableOfContents, getBlockParentPage, uuidToId } from '@simpledotink/notion-utils';
import { PageIcon } from './components/page-icon';
import { PageTitle } from './components/page-title';
// import { LinkIcon } from './icons/link-icon'
import { Header } from './components/header';
import { GoogleDrive } from './components/google-drive';
import { Audio } from './components/audio';
import { File } from './components/file';
import { Equation } from './components/equation';
import { GracefulImage } from './components/graceful-image';
import { LazyImage } from './components/lazy-image';
import { useNotionContext } from './context';
import { cs, isUrl } from './utils';
import { Text } from './components/text';
import { SyncPointerBlock } from './components/sync-pointer-block';
import { AssetWrapper } from './components/asset-wrapper';
import { ExternalComponentGithub } from './components/external-component-github';
import { ExternalComponentGoogleDoc, ExternalComponentGoogleDrive } from './components/external-component-google';
import { DeepnoteComponent } from './components/iframe-componets';
import { List } from './components/list';
import ErrorBoundary from './components/ErrorBoundary';
import { PlaceholderComponent } from './components/placeholder-component';
import { ExternalComponentDropbox } from './components/external-component-dropbox';
import { Button } from './components/button';
import { NavbarComponent } from './components/navbar-component';
import { ExternalComponentAdobeXd } from './components/external-component-adobe-xd';
var tocIndentLevelCache = {};
export var Block = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
    var _31 = useNotionContext(), components = _31.components, fullPage = _31.fullPage, darkMode = _31.darkMode, recordMap = _31.recordMap, mapPageUrl = _31.mapPageUrl, mapImageUrl = _31.mapImageUrl, showTableOfContents = _31.showTableOfContents, minTableOfContentsItems = _31.minTableOfContentsItems, defaultPageIcon = _31.defaultPageIcon, defaultPageCover = _31.defaultPageCover, defaultPageCoverPosition = _31.defaultPageCoverPosition, navbar = _31.navbar;
    // const [activeSection, setActiveSection] = React.useState(null)
    // const [hasToc, setHasToc] = React.useState(false)
    var block = props.block, children = props.children, level = props.level, className = props.className, bodyClassName = props.bodyClassName, header = props.header, footer = props.footer, pageHeader = props.pageHeader, pageFooter = props.pageFooter, pageAside = props.pageAside, pageCover = props.pageCover, hideBlockId = props.hideBlockId, disableHeader = props.disableHeader;
    if (!block) {
        // TODO
        // React.useEffect(() => {
        //   if (!hasToc) {
        //     return
        //   }
        //   const throttleMs = 100
        //   const actionSectionScrollSpy = throttle(() => {
        //     const sections = document.getElementsByClassName('notion-h')
        //     let prevBBox: DOMRect = null
        //     let currentSectionId = activeSection
        //     for (let i = 0; i < sections.length; ++i) {
        //       const section = sections[i]
        //       if (!section || !(section instanceof Element)) continue
        //       if (!currentSectionId) {
        //         currentSectionId = section.getAttribute('data-id')
        //       }
        //       const bbox = section.getBoundingClientRect()
        //       const prevHeight = prevBBox ? bbox.top - prevBBox.bottom : 0
        //       const offset = Math.max(150, prevHeight / 4)
        //       // GetBoundingClientRect returns values relative to the viewport
        //       if (bbox.top - offset < 0) {
        //         currentSectionId = section.getAttribute('data-id')
        //         prevBBox = bbox
        //         continue
        //       }
        //       // No need to continue loop, if last element has been detected
        //       break
        //     }
        //     setActiveSection(currentSectionId)
        //   }, throttleMs)
        //   window.addEventListener('scroll', actionSectionScrollSpy)
        //   actionSectionScrollSpy()
        //   return () => {
        //     window.removeEventListener('scroll', actionSectionScrollSpy)
        //   }
        // }, [hasToc, activeSection])
        return React.createElement(PlaceholderComponent, null);
    }
    if (block.id == 'f3b85fd5-550d-4442-9315-20c63b38252f')
        console.log(block);
    if (block.id == '5431e717-2d2e-4914-a6ac-809cf8a22f40') {
        console.log('fish', block);
    }
    // ugly hack to make viewing raw collection views work properly
    // e.g., 6d886ca87ab94c21a16e3b82b43a57fb
    if (level === 0 && block.type === 'collection_view') {
        ;
        block.type = 'collection_view_page';
    }
    var blockFormat = block === null || block === void 0 ? void 0 : block.format;
    var blockWidth = (blockFormat === null || blockFormat === void 0 ? void 0 : blockFormat.block_page_width)
        ? 0
        : (blockFormat === null || blockFormat === void 0 ? void 0 : blockFormat.block_width) || 0;
    var blockId = hideBlockId
        ? 'notion-block'
        : "notion-block-".concat(uuidToId(block.id));
    switch (block.type) {
        case 'collection_view_page':
        // fallthrough
        case 'page':
            if (level === 0) {
                var _32 = block.format || {}, _33 = _32.page_icon, page_icon = _33 === void 0 ? defaultPageIcon : _33, _34 = _32.page_cover_position, page_cover_position = _34 === void 0 ? defaultPageCoverPosition : _34, page_full_width = _32.page_full_width, page_small_text = _32.page_small_text;
                var _35 = (block.format || {}).page_cover, page_cover = _35 === void 0 ? defaultPageCover : _35;
                if (fullPage) {
                    var properties = block.type === 'page'
                        ? block.properties
                        : {
                            title: (_b = (_a = recordMap.collection[block.collection_id]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.name
                        };
                    var coverPosition = (1 - (page_cover_position || 0.5)) * 100;
                    var pageIcon = (_c = getBlockIcon(block, recordMap)) !== null && _c !== void 0 ? _c : defaultPageIcon;
                    var isPageIconUrl = pageIcon && isUrl(pageIcon);
                    var toc = getPageTableOfContents(block, recordMap);
                    var hasToc = showTableOfContents && toc.length >= minTableOfContentsItems;
                    var hasAside = (hasToc || pageAside) && !page_full_width;
                    var hasPageCover = pageCover || page_cover;
                    // TODO
                    var activeSection_1 = null;
                    var isCollectionViewPage = block.type === 'collection_view_page';
                    var collectionViewPageData = [];
                    if (isCollectionViewPage) {
                        collectionViewPageData['title'] = undefined;
                        if (!properties.title)
                            collectionViewPageData['title'] = (_d = block.properties) === null || _d === void 0 ? void 0 : _d.title;
                        collectionViewPageData['description'] =
                            (_e = recordMap.collection[block['collection_id']]) === null || _e === void 0 ? void 0 : _e.value['description'];
                        collectionViewPageData['cover'] =
                            (_f = recordMap.collection[block['collection_id']]) === null || _f === void 0 ? void 0 : _f.value['cover'];
                        if (collectionViewPageData['cover']) {
                            hasPageCover = true;
                            page_cover = collectionViewPageData['cover'];
                        }
                    }
                    var pageTitle = collectionViewPageData['title'] || (properties === null || properties === void 0 ? void 0 : properties.title);
                    return (React.createElement("div", { className: cs('notion', 'notion-app', darkMode ? 'dark-mode' : 'light-mode', blockId, className) },
                        React.createElement("div", { className: 'notion-viewport' }),
                        React.createElement("div", { className: 'notion-frame' },
                            navbar ? (React.createElement(NavbarComponent, { navbar: navbar, header: header })) : (!disableHeader && React.createElement(Header, { header: header })),
                            React.createElement("div", { className: 'notion-page-scroller' },
                                hasPageCover ? (pageCover ? (pageCover) : (React.createElement(ErrorBoundary, null,
                                    React.createElement("div", { className: "notion-page-cover-wrapper ".concat(isCollectionViewPage
                                            ? 'notion-page-cover-wrapper-collection-viewpage'
                                            : '') },
                                        React.createElement(LazyImage, { src: mapImageUrl(page_cover, block), alt: getTextContent(properties === null || properties === void 0 ? void 0 : properties.title), priority: true, className: 'notion-page-cover', style: {
                                                objectPosition: "center ".concat(coverPosition, "%")
                                            } }))))) : null,
                                React.createElement("main", { className: cs('notion-page', hasPageCover
                                        ? 'notion-page-has-cover'
                                        : 'notion-page-no-cover', page_icon
                                        ? 'notion-page-has-icon'
                                        : 'notion-page-no-icon', isPageIconUrl
                                        ? 'notion-page-has-image-icon'
                                        : 'notion-page-has-text-icon', 'notion-full-page', isCollectionViewPage
                                        ? 'notion-page-collection-viewpage'
                                        : '', (page_full_width || isCollectionViewPage) &&
                                        'notion-full-width', page_small_text && 'notion-small-text', bodyClassName, (page_icon === null || page_icon === void 0 ? void 0 : page_icon.endsWith('.svg')) ? 'has-svg-page-icon' : '') },
                                    page_icon && !isCollectionViewPage && (React.createElement("div", { className: 'notion-page-icon-wrapper ' },
                                        React.createElement(PageIcon, { block: block, defaultIcon: defaultPageIcon }))),
                                    React.createElement(ErrorBoundary, null,
                                        " ",
                                        pageHeader,
                                        " "),
                                    pageTitle && (React.createElement("div", { className: 'notion-title-container' },
                                        page_icon && isCollectionViewPage && (React.createElement(PageIcon, { block: block, defaultIcon: defaultPageIcon })),
                                        React.createElement("h1", { className: 'notion-title' }, pageTitle && (React.createElement(Text, { value: pageTitle, block: block }))))),
                                    isCollectionViewPage &&
                                        collectionViewPageData['description'] && (React.createElement(ErrorBoundary, null,
                                        React.createElement("div", { className: 'collection-view-page-description' },
                                            React.createElement(Text, { value: collectionViewPageData['description'], block: block })))),
                                    block.type === 'page' &&
                                        block.parent_table === 'collection' && (React.createElement(ErrorBoundary, null,
                                        React.createElement(components.collectionRow, { block: block }))),
                                    block.type === 'collection_view_page' && (React.createElement(ErrorBoundary, null,
                                        React.createElement(components.collection, { block: block }))),
                                    React.createElement("div", { className: cs('notion-page-content', hasAside && 'notion-page-content-has-aside', hasToc && 'notion-page-content-has-toc') },
                                        React.createElement("article", { className: 'notion-page-content-inner' }, children),
                                        hasAside && (React.createElement("aside", { className: 'notion-aside' },
                                            hasToc && (React.createElement(ErrorBoundary, null,
                                                React.createElement("div", { className: 'notion-aside-table-of-contents' },
                                                    React.createElement("div", { className: 'notion-aside-table-of-contents-header' }, "Table of Contents"),
                                                    React.createElement("nav", { className: cs('notion-table-of-contents', !darkMode && 'notion-gray') }, toc.map(function (tocItem) {
                                                        var id = uuidToId(tocItem.id);
                                                        return (React.createElement("a", { key: id, href: "#".concat(id), className: cs('notion-table-of-contents-item', "notion-table-of-contents-item-indent-level-".concat(tocItem.indentLevel), activeSection_1 === id &&
                                                                'notion-table-of-contents-active-item') },
                                                            React.createElement("span", { className: 'notion-table-of-contents-item-body', style: {
                                                                    display: 'inline-block',
                                                                    marginLeft: tocItem.indentLevel * 16
                                                                } }, tocItem.text)));
                                                    }))))),
                                            pageAside))),
                                    pageFooter),
                                footer))));
                }
                else {
                    return (React.createElement("main", { className: cs('notion', darkMode ? 'dark-mode' : 'light-mode', 'notion-page', page_full_width && 'notion-full-width', page_small_text && 'notion-small-text', blockId, className, bodyClassName) },
                        React.createElement("div", { className: 'notion-viewport' }),
                        React.createElement(ErrorBoundary, null, pageHeader),
                        block.type === 'page' && block.parent_table === 'collection' && (React.createElement(ErrorBoundary, null,
                            React.createElement(components.collectionRow, { block: block }))),
                        block.type === 'collection_view_page' && (React.createElement(ErrorBoundary, null,
                            React.createElement(components.collection, { block: block }))),
                        React.createElement(ErrorBoundary, null, children),
                        React.createElement(ErrorBoundary, null, pageFooter)));
                }
            }
            else {
                var blockColor = (_g = block.format) === null || _g === void 0 ? void 0 : _g.block_color;
                return (React.createElement(ErrorBoundary, null,
                    React.createElement(components.pageLink, { className: cs('notion-page-link', blockColor && "notion-".concat(blockColor), blockId), href: mapPageUrl(block.id) },
                        React.createElement(PageTitle, { block: block }))));
            }
        case 'header':
        // fallthrough
        case 'sub_header':
        // fallthrough
        case 'sub_sub_header': {
            if (!block.properties)
                return null;
            var blockColor = (_h = block.format) === null || _h === void 0 ? void 0 : _h.block_color;
            var id = uuidToId(block.id);
            var title = getTextContent(block.properties.title) || "Notion Header ".concat(id);
            // we use a cache here because constructing the ToC is non-trivial
            var indentLevel = tocIndentLevelCache[block.id];
            var indentLevelClass = void 0;
            if (indentLevel === undefined) {
                var page = getBlockParentPage(block, recordMap);
                if (page) {
                    var toc = getPageTableOfContents(page, recordMap);
                    var tocItem = toc.find(function (tocItem) { return tocItem.id === block.id; });
                    if (tocItem) {
                        indentLevel = tocItem.indentLevel;
                        tocIndentLevelCache[block.id] = indentLevel;
                    }
                }
            }
            if (indentLevel !== undefined) {
                indentLevelClass = "notion-h-indent-".concat(indentLevel);
            }
            var isH1 = block.type === 'header';
            var isH2 = block.type === 'sub_header';
            var isH3 = block.type === 'sub_sub_header';
            var classNameStr = cs(isH1 && 'notion-h notion-h1', isH2 && 'notion-h notion-h2', isH3 && 'notion-h notion-h3', blockColor && "notion-".concat(blockColor), indentLevelClass, blockId);
            var innerHeader = (React.createElement("span", null,
                React.createElement("div", { id: id, className: 'notion-header-anchor' }),
                React.createElement("a", __assign({ className: 'notion-h-title' }, (!((_j = block.format) === null || _j === void 0 ? void 0 : _j.toggleable) ? { href: "#".concat(id) } : null), { title: title }),
                    React.createElement(Text, { value: block.properties.title, block: block }))));
            var headerBlock = (React.createElement("h4", { className: classNameStr, "data-id": id }, innerHeader));
            //page title takes the h1 so all header blocks are greater
            if (isH1) {
                headerBlock = (React.createElement("h2", { className: classNameStr, "data-id": id }, innerHeader));
            }
            else if (isH2) {
                headerBlock = (React.createElement("h3", { className: classNameStr, "data-id": id }, innerHeader));
            }
            if ((_k = block.format) === null || _k === void 0 ? void 0 : _k.toggleable) {
                var blockColor_1 = (_l = block.format) === null || _l === void 0 ? void 0 : _l.block_color;
                return (React.createElement(ErrorBoundary, null,
                    React.createElement("details", { className: cs('notion-toggle', 'notion-toggle-subheader', blockColor_1 && "notion-".concat(blockColor_1), blockId) },
                        React.createElement("summary", null, headerBlock),
                        React.createElement("div", null, children))));
            }
            else {
                return React.createElement(ErrorBoundary, null, headerBlock);
            }
        }
        case 'divider':
            return React.createElement("hr", { className: cs('notion-hr', blockId) });
        case 'text': {
            if (!block.properties && !((_m = block.content) === null || _m === void 0 ? void 0 : _m.length)) {
                return React.createElement("div", { className: cs('notion-blank', blockId) }, "\u00A0");
            }
            var blockColor = (_o = block.format) === null || _o === void 0 ? void 0 : _o.block_color;
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: cs('notion-text', blockColor && "notion-".concat(blockColor), blockId) },
                    ((_p = block.properties) === null || _p === void 0 ? void 0 : _p.title) && (React.createElement(Text, { value: block.properties.title, block: block })),
                    children && React.createElement("div", { className: 'notion-text-children' }, children))));
        }
        case 'bulleted_list':
        // fallthrough
        case 'numbered_list':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(List, { block: block }, children)));
        case 'tweet':
        // fallthrough
        case 'maps':
        // fallthrough
        case 'pdf':
        // fallthrough
        case 'figma':
        // fallthrough
        case 'typeform':
        // fallthrough
        case 'codepen':
        // fallthrough
        case 'excalidraw':
        // fallthrough
        case 'image':
        // fallthrough
        case 'gist':
        // fallthrough
        case 'embed':
        // fallthrough
        case 'video':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(AssetWrapper, { blockId: blockId, block: block })));
        case 'drive': {
            var properties = (_q = block.format) === null || _q === void 0 ? void 0 : _q.drive_properties;
            if (!properties) {
                //check if this drive actually needs to be embeded ex. google sheets or doc.
                var url = new URL(block.properties.source[0][0]);
                var domain = url.hostname;
                if (((_r = block.format) === null || _r === void 0 ? void 0 : _r.display_source) || domain === 'docs.google.com') {
                    return (React.createElement(ErrorBoundary, null,
                        React.createElement(AssetWrapper, { blockId: blockId, block: block })));
                }
            }
            return (React.createElement(ErrorBoundary, null,
                React.createElement(GoogleDrive, { block: block, className: blockId })));
        }
        case 'audio':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(Audio, { block: block, className: blockId })));
        case 'file':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(File, { block: block, className: blockId })));
        case 'equation': {
            var math = block.properties.title[0][0];
            if (!math)
                return null;
            return (React.createElement(ErrorBoundary, null,
                React.createElement(Equation, { math: math, block: true, className: blockId })));
        }
        case 'code': {
            if (block.properties.title) {
                var content = getBlockTitle(block, recordMap);
                var language = block.properties.language
                    ? block.properties.language[0][0]
                    : '';
                var caption = block.properties.caption;
                // TODO: add className
                return (React.createElement(ErrorBoundary, null,
                    React.createElement(components.code, { key: block.id, language: language || '', code: content }),
                    caption && (React.createElement("figcaption", { className: 'notion-asset-caption' },
                        React.createElement(Text, { value: caption, block: block })))));
            }
            break;
        }
        case 'column_list':
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: cs('notion-row', blockId, 'remove-minwidth'), style: {
                        minWidth: blockWidth || 0,
                        position: 'relative',
                        left: blockWidth ? 'calc(0px - var(--body-padding))' : '0px',
                        maxWidth: '100vw',
                        alignSelf: 'center'
                    } }, children)));
        case 'column': {
            // note: notion uses 46px
            var spacerWidthN = 46;
            var spacerWidth = "".concat(spacerWidthN, "px");
            var parent_1 = (_s = recordMap.block[block.parent_id]) === null || _s === void 0 ? void 0 : _s.value;
            var ratioTotal = (parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.content.reduce(function (acc, id) {
                var _a, _b, _c;
                return acc + ((_c = (_b = (_a = recordMap.block[id]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.format) === null || _c === void 0 ? void 0 : _c.column_ratio) ||
                    0;
            }, 0)) || 1;
            var ratio = (((_t = block.format) === null || _t === void 0 ? void 0 : _t.column_ratio) || 0.5) / ratioTotal;
            var columns = (_u = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.content) === null || _u === void 0 ? void 0 : _u.length;
            var rows = (_v = block.content) === null || _v === void 0 ? void 0 : _v.length;
            // the with of the column is the width of the parent minus the width of the spacers
            var width = "calc((100% - ".concat(spacerWidthN * (columns - 1), "px) * ").concat(ratio, ")");
            var style = { width: width };
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: cs('notion-column', 
                    // notion removes image for single columned bookmark
                    rows == 1 && columns > 1 && 'notion-single-column', blockId), style: style }, children),
                React.createElement("div", { className: 'notion-spacer', style: { width: spacerWidth } })));
        }
        case 'quote': {
            if (!block.properties)
                return null;
            var blockColor = (_w = block.format) === null || _w === void 0 ? void 0 : _w.block_color;
            return (React.createElement(ErrorBoundary, null,
                React.createElement("blockquote", { className: cs('notion-quote', blockColor && "notion-".concat(blockColor), blockId) },
                    React.createElement(Text, { value: block.properties.title, block: block }),
                    children)));
        }
        case 'collection_view':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(components.collection, { block: block, className: blockId })));
        case 'callout':
            if (components.callout) {
                return (React.createElement(ErrorBoundary, null,
                    React.createElement(components.callout, { block: block, className: blockId })));
            }
            else {
                return (React.createElement(ErrorBoundary, null,
                    React.createElement("div", { className: cs('notion-callout', ((_x = block.format) === null || _x === void 0 ? void 0 : _x.block_color) &&
                            "notion-".concat((_y = block.format) === null || _y === void 0 ? void 0 : _y.block_color, "_co"), blockId) },
                        React.createElement(PageIcon, { block: block }),
                        React.createElement("div", { className: 'notion-callout-text' },
                            React.createElement(Text, { value: (_z = block.properties) === null || _z === void 0 ? void 0 : _z.title, block: block }),
                            children))));
            }
        case 'bookmark': {
            if (!block.properties)
                return null;
            var title = getTextContent((_0 = block.properties) === null || _0 === void 0 ? void 0 : _0.title);
            if (!title) {
                title = getTextContent((_1 = block.properties) === null || _1 === void 0 ? void 0 : _1.link);
            }
            if (title) {
                if (title === null || title === void 0 ? void 0 : title.startsWith('http')) {
                    try {
                        var url = new URL(title);
                        title = url.hostname;
                    }
                    catch (err) {
                        // ignore invalid links
                    }
                }
            }
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: 'notion-row' },
                    React.createElement(components.link, { target: '_blank', rel: 'noopener noreferrer', className: cs('notion-bookmark', ((_2 = block.format) === null || _2 === void 0 ? void 0 : _2.block_color) &&
                            "notion-".concat(block.format.block_color), blockId), href: block.properties.link[0][0] },
                        React.createElement("div", null,
                            title && (React.createElement("div", { className: 'notion-bookmark-title' },
                                React.createElement(Text, { value: [[title]], block: block }))),
                            ((_3 = block.properties) === null || _3 === void 0 ? void 0 : _3.description) && (React.createElement("div", { className: 'notion-bookmark-description' },
                                React.createElement(Text, { value: (_4 = block.properties) === null || _4 === void 0 ? void 0 : _4.description, block: block }))),
                            React.createElement("div", { className: 'notion-bookmark-link' },
                                ((_5 = block.format) === null || _5 === void 0 ? void 0 : _5.bookmark_icon) && (React.createElement(GracefulImage, { src: (_6 = block.format) === null || _6 === void 0 ? void 0 : _6.bookmark_icon, alt: title, loading: 'lazy' })),
                                React.createElement("div", null,
                                    React.createElement(Text, { value: (_7 = block.properties) === null || _7 === void 0 ? void 0 : _7.link, block: block })))),
                        ((_8 = block.format) === null || _8 === void 0 ? void 0 : _8.bookmark_cover) && (React.createElement("div", { className: 'notion-bookmark-image' },
                            React.createElement(GracefulImage, { src: (_9 = block.format) === null || _9 === void 0 ? void 0 : _9.bookmark_cover, alt: getTextContent((_10 = block.properties) === null || _10 === void 0 ? void 0 : _10.title), loading: 'lazy' })))))));
        }
        case 'toggle':
            return (React.createElement(ErrorBoundary, null,
                React.createElement("details", { className: cs('notion-toggle', blockId) },
                    React.createElement("summary", null,
                        React.createElement(Text, { value: (_11 = block.properties) === null || _11 === void 0 ? void 0 : _11.title, block: block })),
                    React.createElement("div", null, children))));
        case 'table_of_contents': {
            var page = getBlockParentPage(block, recordMap);
            if (!page)
                return null;
            var toc = getPageTableOfContents(page, recordMap);
            var blockColor = (_12 = block.format) === null || _12 === void 0 ? void 0 : _12.block_color;
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: cs('notion-table-of-contents', blockColor && "notion-".concat(blockColor), blockId) }, toc.map(function (tocItem) { return (React.createElement("a", { key: tocItem.id, href: "#".concat(uuidToId(tocItem.id)), className: 'notion-table-of-contents-item' },
                    React.createElement("span", { className: 'notion-table-of-contents-item-body', style: {
                            display: 'inline-block',
                            marginLeft: tocItem.indentLevel * 24
                        } }, tocItem.text))); }))));
        }
        case 'to_do': {
            var isChecked = ((_15 = (_14 = (_13 = block.properties) === null || _13 === void 0 ? void 0 : _13.checked) === null || _14 === void 0 ? void 0 : _14[0]) === null || _15 === void 0 ? void 0 : _15[0]) === 'Yes';
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: cs('notion-to-do', blockId) },
                    React.createElement("div", { className: 'notion-to-do-item' },
                        React.createElement(components.checkbox, { blockId: blockId, isChecked: isChecked }),
                        React.createElement("div", { className: cs('notion-to-do-body', isChecked && "notion-to-do-checked") },
                            React.createElement(Text, { value: (_16 = block.properties) === null || _16 === void 0 ? void 0 : _16.title, block: block }))),
                    React.createElement("div", { className: 'notion-to-do-children' }, children))));
        }
        case 'transclusion_container':
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: cs('notion-sync-block', blockId) }, children)));
        case 'transclusion_reference':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(SyncPointerBlock, __assign({ block: block, level: level + 1 }, props))));
        case 'alias': {
            var blockPointerId = (_18 = (_17 = block === null || block === void 0 ? void 0 : block.format) === null || _17 === void 0 ? void 0 : _17.alias_pointer) === null || _18 === void 0 ? void 0 : _18.id;
            var linkedBlock = (_19 = recordMap.block[blockPointerId]) === null || _19 === void 0 ? void 0 : _19.value;
            if (!linkedBlock) {
                // console.info('"alias" missing block', blockPointerId)
                return null;
            }
            return (React.createElement(ErrorBoundary, null,
                React.createElement(components.pageLink, { className: cs('notion-page-link', blockPointerId), href: mapPageUrl(blockPointerId) },
                    React.createElement(PageTitle, { block: linkedBlock }))));
        }
        case 'table':
            return (React.createElement(ErrorBoundary, null,
                React.createElement("table", { className: cs('notion-simple-table', blockId) },
                    React.createElement("tbody", null, children))));
        case 'table_row': {
            var backgroundColor = ((_20 = block.format) === null || _20 === void 0 ? void 0 : _20.block_color) || null;
            var tableBlock = recordMap.block[block.parent_id]
                .value;
            var order = (_21 = tableBlock.format) === null || _21 === void 0 ? void 0 : _21.table_block_column_order;
            var formatMap_1 = (_22 = tableBlock.format) === null || _22 === void 0 ? void 0 : _22.table_block_column_format;
            return (React.createElement("tr", { className: cs('notion-simple-table-row', blockId, backgroundColor ? "notion-".concat(backgroundColor) : '') }, order === null || order === void 0 ? void 0 : order.map(function (column) {
                var _a, _b;
                var color = formatMap_1 && formatMap_1[column] ? (_a = formatMap_1[column]) === null || _a === void 0 ? void 0 : _a.color : null;
                return (React.createElement("td", { key: column, className: color ? "notion-".concat(color) : '', style: {
                        width: formatMap_1 && formatMap_1[column] && ((_b = formatMap_1[column]) === null || _b === void 0 ? void 0 : _b.width)
                            ? formatMap_1[column].width
                            : 120
                    } },
                    React.createElement("div", { className: 'notion-simple-table-cell' },
                        React.createElement(Text, { value: block.properties ? block.properties[column] : [['ㅤ']], block: block }))));
            })));
        }
        case 'deepnote':
            return (React.createElement(ErrorBoundary, null,
                React.createElement(DeepnoteComponent, { block: block })));
        case 'external_object_instance':
            switch ((_23 = block.format) === null || _23 === void 0 ? void 0 : _23.domain) {
                case 'github.com':
                    return (React.createElement(ErrorBoundary, null,
                        React.createElement(ExternalComponentGithub, { original_url: (_24 = block.format) === null || _24 === void 0 ? void 0 : _24.original_url, block: true, className: blockId })));
                case 'docs.google.com':
                    return (React.createElement(ErrorBoundary, null,
                        React.createElement(ExternalComponentGoogleDoc, { original_url: (_25 = block.format) === null || _25 === void 0 ? void 0 : _25.original_url, block: block, className: blockId })));
                case 'drive.google.com':
                    return (React.createElement(ErrorBoundary, null,
                        React.createElement(ExternalComponentGoogleDrive, { original_url: (_26 = block.format) === null || _26 === void 0 ? void 0 : _26.original_url, block: block, className: blockId })));
                case 'www.dropbox.com':
                    return (React.createElement(ExternalComponentDropbox, { original_url: (_27 = block.format) === null || _27 === void 0 ? void 0 : _27.original_url, block: block }));
                default:
                    // console.log(block, 'blockie')
                    if (((_28 = block.format) === null || _28 === void 0 ? void 0 : _28.uri) &&
                        String(block.format.uri).indexOf('https://xd.adobe.com') != -1) {
                        return (React.createElement(ExternalComponentAdobeXd, { block: block, original_url: block.format.original_url }));
                    }
                    if (process.env.NODE_ENV !== 'production') {
                        console.log("Unsupported external_object_instance domain ".concat((_29 = block.format) === null || _29 === void 0 ? void 0 : _29.domain, ": ") +
                            block.type, JSON.stringify(block, null, 2));
                    }
                    return React.createElement(PlaceholderComponent, null);
            }
        case 'whimsical':
        case 'miro': {
            if (!(block === null || block === void 0 ? void 0 : block.format))
                return null;
            var width = ((_30 = block.format) === null || _30 === void 0 ? void 0 : _30.block_width) || '100%';
            return (React.createElement("iframe", { style: { maxWidth: '100%', width: width, margin: 'auto' }, src: block.format.display_source, 
                // width={block.format.block_width}
                height: block.format.block_height }));
        }
        case 'ai_block':
        case 'link_to_page':
        case 'copy_indicator': {
            return null;
        }
        case 'button': {
            return React.createElement(Button, { block: block });
        }
        default:
            if (process.env.NODE_ENV !== 'production') {
                console.info('Unsupported type ' + block.type, JSON.stringify(block, null, 2));
            }
            return React.createElement(PlaceholderComponent, null);
    }
    return null;
};
//# sourceMappingURL=block.js.map